import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { none, FaqScreen } from './faqScreen';

interface FaqState {
    viewModel: FaqScreen.ViewModel
}

const initialState: FaqState = {
    viewModel: none()
}

export const faqSlice = createSlice({
    name: 'faq',
    initialState,
    reducers: {
        setViewModel: (state, action: PayloadAction<FaqScreen.ViewModel>) => {
            state.viewModel = action.payload
        }
    }
})

export const { setViewModel } = faqSlice.actions

export default faqSlice.reducer